/**
 * Regra institucional da média geral: média aritmética da pontuação (0..1)
 * de todas as questões no recorte; questão não respondida vale zero. Não há
 * ponderação por tema. Assim, média e participação permanecem grandezas
 * distintas e todas as telas produzem o mesmo resultado.
 */
export const calcularMediaGeral = (questoes = [], respostas = []) => {
  if (!Array.isArray(questoes) || questoes.length === 0) return 0;
  const porQuestao = new Map((respostas || []).map((r) => [r.idQuestao, r]));
  const soma = questoes.reduce((total, q) => {
    const resposta = q.resposta || porQuestao.get(q.id);
    return total + (Number(resposta?.pontuacao) || 0);
  }, 0);
  return (soma / questoes.length) * 100;
};
